module.exports = __webpack_public_path__ + "static/media/leadScore.661d3914.png";